import { apiServerRoutes } from "../constants/apiRoutes";
import {
  deleteAPICallServer,
  getAPICallServer,
  postAPICallServer,
  putAPICallServer,
} from "../utils/axios.util";

class CardService {
  fetch(req: any) {
    return getAPICallServer(apiServerRoutes.CARD_FETCH, req);
  }

  create(req: any) {
    return postAPICallServer(apiServerRoutes.CARD_CREATE, req.body, req);
  }

  remove(req: any) {
    const { id } = req.body;
    return deleteAPICallServer(
      apiServerRoutes.CARD_DELETE.replace(":id", id),
      req
    );
  }

  makeDefault(req: any) {
    const { id } = req.body;
    return putAPICallServer(
      apiServerRoutes.CARD_DEFAULT.replace(":id", id),
      req.body,
      req
    );
  }

  updateById(req: any) {
    const { id } = req.body;
    return putAPICallServer(
      `${apiServerRoutes.CARD_CREATE}/${id}`,
      req.body,
      req
    );
  }
}

export default new CardService();
